import { render, staticRenderFns } from "./editonpayp_mobile.vue?vue&type=template&id=6b94e4e7&scoped=true&"
import script from "./editonpayp_mobile.vue?vue&type=script&lang=js&"
export * from "./editonpayp_mobile.vue?vue&type=script&lang=js&"
import style0 from "./editonpayp_mobile.vue?vue&type=style&index=0&id=6b94e4e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b94e4e7",
  null
  
)

export default component.exports